import BaseService from "./BaseService";

export default {
  index() {
    var url = "/recent-user-accounts";

    return BaseService.get(url);
  },
};
